export default __webpack_public_path__ + "static/media/card-shadow-none@3x.8682c08b.png";